fragment LocationWeatherFragment on Weather {
    temperature
    condition
    location
    localTime
}
